<script setup lang="ts">
import type { BuildStatus } from '@kilnci/shared';

defineProps<{
  status: BuildStatus;
}>();
</script>

<template>
  <span class="badge" :class="`badge-${status}`">
    {{ status }}
  </span>
</template>

<style scoped>
.badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: var(--theme-transition);
}

.badge-pending {
  background-color: var(--color-warning-bg);
  color: var(--color-warning-text);
}

.badge-running {
  background-color: var(--color-running-bg);
  color: var(--color-running-text);
}

.badge-success {
  background-color: var(--color-success-bg);
  color: var(--color-success-text);
}

.badge-failed {
  background-color: var(--color-error-bg);
  color: var(--color-error-text);
}

.badge-cancelling,
.badge-cancelled {
  background-color: var(--color-cancelled-bg);
  color: var(--color-cancelled-text);
}
</style>
